var classes = {"root":"iUo1k"};

export { classes as default };
